import Tariffmodifiers from "../../../utils/services/project/accounting/tariffPlanModifiersService";
import crudTemplate from "../../../templates/crudTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(Tariffmodifiers);
function prepareItem(i) {
  i.type_text =
    i.type === "absolute" ? i18n.t("tariff-plans.absolute") : i.type_text;
  i.type_text =
    i.type === "factor" ? i18n.t("tariff-plans.factor") : i.type_text;
  i.type_text =
    i.type === "relative" ? i18n.t("tariff-plans.relative") : i.type_text;
  i.type = i.type ? i.type : null;
  i.component_name = i._component && i._component.name;
  i.component_id = i._component && i._component.id;

  return i;
}
const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getItem() {
    let item = crud.getters.getItem(state);
    return item.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = {
      _tariff_plan: { id: item.tariff_plan_id },
      project_id: item.project_id,
      name: item.name,
      _tariff_component: { id: item.component_id },
      priority: item.priority,
      type: item.type_text.value
    };
    return crud.actions.create(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  },
  update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = {
      id: item.id,
      _tariff_plan: { id: item.tariff_plan_id },
      project_id: item.project_id,
      name: item.name,
      _tariff_component: { id: item._component.id },
      priority: item.priority,
      type: item.type_text.value || item.type
    };
    return crud.actions.update(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
